import type { Meta } from "@/types/pagination-type";
import type { Review, ReviewResponse, NewReview } from "@/types/review-type";
import { toast } from "vue3-toastify";

export const useReviewStore = defineStore("review", () => {
    const reviews = ref<ReviewResponse>({
        success: false,
        message: "",
        data: [],
        meta: {
            total: 0,
            current_page: 0,
            per_page: 0,
            last_page: 0,
        } as Meta,
    });
    const getReviews = async (productID: number) => {
        await fetch(`/products/${productID}/reviews`).then((res) => {
            reviews.value = res as ReviewResponse;
        });
    }
    const createReview = async (newReview: NewReview, productID: number) => {
        await fetch(`/products/${productID}/reviews`, {
            method: "POST",
            body: JSON.stringify(newReview)
        }).then(async (res) => {
            await getReviews(productID);
        }).catch((err) => {
            toast.error(err.data.message);
        });
    }
    const updateReview = async (newReview: NewReview, productID: number, reviewID: number) => {
        await fetch(`/products/${productID}/reviews/${reviewID}`, {
            method: "PUT",
            body: JSON.stringify(newReview)
        }).then(async (res) => {
            await getReviews(productID);
        });
    }
    const deleteReview = async (productID: number, reviewID: number) => {
        await fetch(`/products/${productID}/reviews/${reviewID}`, {
            method: "DELETE",
        }).then(async (res) => {
            await getReviews(productID);
        });
    }
    return {
        reviews,
        getReviews,
        createReview,
        updateReview,
        deleteReview,
    };
});